export class InsufficientlyAuthenticationError extends Error {
    public name = "InsufficientlyAuthenticationError";
    constructor(message = "Insufficiently Authentication", public missingFields?: string[]) {
        super(message);
    }
}
